import React, {useEffect, useState} from "react";
import "../CSS/Services2.css";
import axios from "axios";

const Services2=({title})=>{
  
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchFilteredServices = async () => {
      try {
        const response = await axios.get(`https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getServicesSection2`, {
          params: { title },
        });
        setServices(response.data);
        console.log("responseofservice2:", response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchFilteredServices();
  }, [title]);

    return(
        <>
            <section className="services3">
  <div className="container">
 
  {services.map((service, index) => (
  <div key={index} className="row justify-content-center text-center">
      <div className="col-md-10 col-lg-8">
        <div className="header-section">
        {/* {services.length > 0 && ( */}
      
            <>
                  <h2 className="title blackthemegradient">{service.title2}</h2>
                  <p className="description text-white">
                    {service.description2}
                  </p>
                </>
        {/* )} */}
        </div>
      </div>
    </div>
  ))}
  <div className="row">
  {services.length > 0 &&
            services[0].subtitles.map((subtitle, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="single-service" style={{backgroundColor:"white"}}>
                  <div className="content">
                  <span className="icon">
                    <img src={subtitle.subimage} alt={subtitle.subtitle} />
                    </span>
                    <h3 className="title blackthemegradient">{subtitle.subtitle}</h3>
                    <p className="description text-black">{subtitle.subdescription}</p>
                    {/* <a href="#" className="learn-more">
                    Learn More
                    </a> */}
                  </div>
                  <span className="circle-before" />
                </div>
              </div>
            ))}
            <div className="shape-blob2"></div>
  </div>
  </div>
</section>

        </>
    );
}

export default Services2;